/* A stable browsing-session mix within each Shopify results page.
   Pagination membership, filter results and shopper-selected sorting stay native. */
(() => {
  let seed;
  function sessionSeed() {
    if (seed) return seed;
    const key = 'med-collection-mix-v31';
    try { seed = sessionStorage.getItem(key); } catch (_) { /* Private storage may be disabled. */ }
    if (!seed) {
      const values = new Uint32Array(1);
      if (window.crypto?.getRandomValues) window.crypto.getRandomValues(values);
      else values[0] = Math.floor(Math.random() * 4294967296);
      seed = String(values[0]);
      try { sessionStorage.setItem(key, seed); } catch (_) { /* Keep the in-memory seed. */ }
    }
    return seed;
  }
  function rank(value) {
    let hash = 2166136261;
    for (let i = 0; i < value.length; i++) hash = Math.imul(hash ^ value.charCodeAt(i), 16777619);
    hash ^= hash >>> 16;
    hash = Math.imul(hash, 0x7feb352d);
    hash ^= hash >>> 15;
    hash = Math.imul(hash, 0x846ca68b);
    return (hash ^ (hash >>> 16)) >>> 0;
  }
  function mix() {
    if (window.Shopify?.designMode || new URL(location.href).searchParams.has('sort_by')) return;
    document.querySelectorAll('results-list[data-med-shuffle-collection]').forEach(list => {
      const grid = list.querySelector('ul.product-grid');
      if (!grid) return;
      const cards = [...grid.children].filter(card => card.matches('li[data-product-id][data-page]'));
      if (cards.length < 2 || cards.some(card => card.contains(document.activeElement))) return;
      const key = sessionSeed() + ':' + list.dataset.medShuffleCollection + ':';
      const ordered = [...cards].sort((a, b) => {
        const pageDifference = Number(a.dataset.page) - Number(b.dataset.page);
        return pageDifference || rank(key + a.dataset.productId) - rank(key + b.dataset.productId) || a.dataset.productId.localeCompare(b.dataset.productId);
      });
      if (ordered.every((card, index) => card === cards[index])) return;
      // Move the existing nodes: product links, images and accessibility labels stay attached.
      const fragment = document.createDocumentFragment();
      for (const card of ordered) fragment.append(card);
      grid.append(fragment);
    });
  }
  function start() {
    const main = document.querySelector('main');
    if (!main || !main.querySelector('results-list[data-med-shuffle-collection]')) return;
    mix();
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      queueMicrotask(() => { pending = false; mix(); });
    }).observe(main, { childList: true, subtree: true });
    window.addEventListener('popstate', mix);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
